export default "__VITE_ASSET__BXHVTcRb__"